import { IDocumentResponse } from '../interfaces/documentResponse';
import { axiosAdmin } from './axios';

export namespace DocumentService {
  const baseUrl = (customerId: number) => `/customers/${customerId}/documents`;

  export function getCustomerDocuments(customerId: number): Promise<IDocumentResponse[]> {
    return axiosAdmin.get<IDocumentResponse[]>(baseUrl(customerId))
      .then(({ data }) => data);
  }

  export function downloadDocument(customerId: number, revisionId: string): Promise<Blob> {
    return axiosAdmin.get<Blob>(baseUrl(customerId) + `/${revisionId}`, { responseType: 'blob' })
      .then(({ data }) => data);
  }

  export function getDocumentRevisions(customerId: number, revisionId: string): Promise<IDocumentResponse[]> {
    return axiosAdmin.get<IDocumentResponse[]>(baseUrl(customerId) + `/${revisionId}/revisions`)
      .then(({ data }) => data);
  }

  export function downloadDocumentRevision(customerId: number, curRevisionId: string, revisionId: string): Promise<Blob> {
    return axiosAdmin.get<Blob>(baseUrl(customerId) + `/${curRevisionId}/revisions/${revisionId}`, { responseType: 'blob' })
      .then(({ data }) => data);
  }
}